'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFlashAuto = function ImageFlashAuto(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 2v12h3v9l7-12H9l4-9H3zm16 0h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2zm-2.15 5.65L18 4l1.15 3.65h-2.3z' })
  );
};
ImageFlashAuto = (0, _pure2.default)(ImageFlashAuto);
ImageFlashAuto.displayName = 'ImageFlashAuto';
ImageFlashAuto.muiName = 'SvgIcon';

exports.default = ImageFlashAuto;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/image/flash-auto.js
 ** module id = 2093
 ** module chunks = 0
 **/